/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown>, total: NonNullable<unknown> }} User_List_Showing_RangeInputs */



/**
* | output |
* | --- |
* | "Showing {from} to {to} of {total} users" |
*
* @param {User_List_Showing_RangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_showing_range = /** @type {((inputs: User_List_Showing_RangeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Showing_RangeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Affichage de ${i?.from} à ${i?.to} sur ${i?.total} utilisateurs`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mostrando ${i?.from} a ${i?.to} de ${i?.total} usuarios`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Mostrando ${i?.from} a ${i?.to} de ${i?.total} usuários`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Mostrati da ${i?.from} a ${i?.to} di ${i?.total} utenti`)
	return /** @type {LocalizedString} */ (`Showing ${i?.from} to ${i?.to} of ${i?.total} users`)
});